var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPinterest = function SvgPinterest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pinterestsvg0{fill:#ca2127}.pinterestsvg1{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pinterestsvg0",
    d: "M354.7 179.5c0 96.8-78.5 175.3-175.3 175.3-96.8 0-175.3-78.5-175.3-175.3C4.1 82.7 82.6 4.2 179.4 4.2c96.8 0 175.3 78.5 175.3 175.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pinterestsvg1",
    d: "M164.7 62.9c-49.4 5.3-98.6 43.3-100.6 97.7-1.3 33.2 12.6 58.1 45.8 65.1 3.8-15.7 4.5-24.2 4.5-24.2s-14.6-14-16.1-22.9C86.1 107 185 58.1 236.9 108.1c35.8 34.7 12.2 141.4-45.6 130.3-55.4-10.6 27.1-95.5-17.1-112.2-35.9-13.6-55 41.5-38 68.8-10 47-31.5 91.3-22.8 150.2 28.3-19.5 37.8-56.9 45.6-95.9 14.2 8.2 21.8 16.8 39.9 18.1 66.8 4.9 104.1-63.5 95-126.7-8.2-56-66.8-84.5-129.2-77.8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPinterest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pinterest.717a72bad7f518e2a4906909f55ff0da.svg";